import React, { Component } from 'react';
import { connect } from 'react-redux';
import { filterDispatcher, pageresultState, filterSelectorState, repositoryState, combineStates, currentNodeState, identityState,productState, viewSettingsState, mobileItemDetailState, siteSettingsState } from '../../../../store';
import { getAccessories, getProductLink, translateProperty } from '../../../../util';
import { PropTypes } from 'prop-types';
import { ActionPanel, CartItemDetail, CustomContent, ProductCode, ProductDescription, ProductImage, ProductPrice, ProductStock, ProductsViewer, StockFilter, SvgImage } from '../../../../components';
import { Box, MenuItem, Select, IconButton as MuiIconButton, Drawer, Divider } from '@mui/material';
import { FirstPage, LastPage, NavigateBefore, NavigateNext } from '@mui/icons-material';
import { DownArrowIconNew, OpenInNewWindow, arrowRightIcon, closePopup } from '../../../../../style/images';
import { translate } from '../../../../services';
import { NoResultsFound } from './NoResultsFound';
import classNames from 'classnames';
import { ProductItemDetail } from '../../../../components/ProductItemDetail';
import { BomItem } from '../model';
import Pagination from '../../../../components/Pagination';

const combine = ( ...args ) => i => args.reduce( ( current, item ) => item( i ) && current, true );

const validValue = val => val && val.value !== 'DO NOT DISPLAY' && val.value !== 'NOT&#032;APPLICABLE';
const isSelected = val => val.isSelected;
const isAssignable = val => val.isAssignable;

const mergedMetaDataWithBomItemsTranslations = ( metaData, filterGroups = [] ) => {
  if ( !( 'bomItemFields' in metaData ) || metaData.bomItemFields.length === 0 ) {
    return metaData;
  }
  // will create translations for all the bomItemFields
  return {
    ...metaData,
    translations: metaData?.bomItemFields?.reduce( ( agg, current ) => {
      const match = filterGroups?.firstOrDefault( g => g.identifier && g.identifier?.endsWith( `.${current}` ) );
      agg[current] = ( match && match.name ) || current;
      return agg;
    }, {} )
  }
};
const addMetadataTranslation =(item,filterGroups = [])=>{
  if ( !( 'bomItemFields' in item ) || item.bomItemFields.length === 0 ) {
    return item;
  }
  return {
    ...item,
    translations: item?.bomItemFields?.reduce( ( agg, current ) => {
      const match = filterGroups?.firstOrDefault( g => g.identifier && g.identifier?.endsWith( `.${current}` ) );
      agg[current] = ( match && match.name ) || current;
      return agg;
    }, {} )
  }
};


export class ProductsListComponent extends Component {
  constructor() {
    super();
    this.handleConfigureByCode = this.handleConfigureByCode.bind( this );
    this.onFilterChanged = this.onFilterChanged.bind( this );
    this.mounted = false;
    this.hasFilterApplied = false;
    this.state = {
      page:0, 
      rowsPerPage:10,
      currentProducts:[],
      showItemDetails:false,
      currentItem:{},
      open:false,
      expandedItemKeys:[],
      isLoading:false
    }
    this.setProductsPerPage = this.setProductsPerPage.bind(this);
  }

  close = ()=>{
    this.setState({open:false})
  }

  open=()=>{
    this.setState({open:true})
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    // remove any userDefined stuff
    this.hasFilterApplied && this.onFilterChanged( '' );
    // kill the userdefined stuff
    this.mounted = false;
  }
  
  getCompleteProductsSet( products, metaData ) {
    // ECQ-424 need access to the meta data to show the translation
    if ( 'allSatisfied' in metaData || ( 'bomItemFields' in metaData && metaData.bomItemFields.length > 0 ) ) {
      return products.map( p => ({...p, ...metaData, isExpandable: this.isExpandable}) )
    }
    return products.map(p => ({...p, isExpandable: this.isExpandable}));
  }

  getChildContext() {
    const { currentNode, pageresult = { request: { } } } = this.props;
    return { 
      modelToLoad: this.props.currentSelector.modelToLoad || this.props.currentNode.customProperties && this.props.currentNode.customProperties.modelToLoad,
      properties: {
        ...currentNode.customProperties,
        ...pageresult.request.metaData
      },
      filterSelectors: pageresult.request.filterGroups
    };
  }

  handleConfigureByCode() {
    const { pageresult, onConfigureRequest } = this.props;
    return onConfigureRequest( pageresult.request.metaData.code.actualCode );
  }

  onScrollHandler = e => {
    const { currentSelector, filterSelectors, pageresult, user } = this.props;
    const { clientHeight, scrollTop, scrollHeight } = e.target;

    if ( scrollTop > ( scrollHeight - clientHeight ) * 0.75 && pageresult.page + 1 < pageresult.totalPages && !this.isLoadingMore ) {
      this.isLoadingMore = true;
      this.props.updateSelectedValue( filterSelectors, currentSelector.selector, user, null, pageresult.page + 1, pageresult.request.hasStockFilter ).then( () => this.isLoadingMore = false );
    }
  }

  nextPage = (page, rowsPerPage) =>{
    // if ( this.state.isSearching ) return;
    let { pageSize, pageresult } = this.props;
    const { currentSelector, filterSelectors, user } = this.props;
    // if (pageresult.results.length<this.props.pageresult.totalItems ){
    //   this.setState( { isLoading:true, stockFilterSelected: pageresult.request.hasStockFilter ? pageresult.request.hasStockFilter : this.state.stockFilterSelected }, () => {
    //     this.isLoadingMore = true;
    //   this.props.updateSelectedValue( filterSelectors, currentSelector.selector, user, null, pageresult.page + 1, pageresult.request.hasStockFilter, this.state.rowsPerPage ).then( () => this.setState( { isLoading:false}));
    //      } );
    // }
    this.setState( { isLoading:true, stockFilterSelected: pageresult.request.hasStockFilter ? pageresult.request.hasStockFilter : this.state.stockFilterSelected }, () => {
        this.isLoadingMore = true;
      this.props.updateSelectedValue( filterSelectors, currentSelector.selector, user, null, page, pageresult.request.hasStockFilter, rowsPerPage ).then( () => this.setState( { isLoading:false}));} );
  }
  onFilterChanged( searchValue ) {
    this.hasFilterApplied = true;
    const { currentSelector, filterSelectors, pageresult } = this.props;
    const searchSelector = currentSelector.selector;
    if ( !searchSelector.sqlFilters.any( f => f.isUserDefined ) ) {
      searchSelector.sqlFilters.push( { contains: searchValue, property: 'MaterialNameLso', isUserDefined: true } );
      searchSelector.sqlFilters.push( { contains: searchValue, property: 'Translation%', isUserDefined: true } );
      searchSelector.sqlFilters.push( { contains: searchValue, property: 'Code', isUserDefined: true } );
      searchSelector.sqlFilters.push( { contains: searchValue, property: 'Name', isUserDefined: true } );
    } else {
      searchSelector.sqlFilters.forEach( f => {
        if ( f.isUserDefined ) { 
          f.contains = searchValue;
          f.startsWith = null;
          f.equalsTo = null;
        }
      } );
    }
    this.isLoadingMore = true;
    this.props.updateSelectedValue( filterSelectors, searchSelector, null, 0, pageresult.request.hasStockFilter ).then( () => this.isLoadingMore = false );
  }

  getTooltip() {
    const { pageresult } = this.props;
    const notShownValues = ['DO NOT DISPLAY', 'NOT APPLICABLE'];
    const selectedFilters = [];
  
    for( let filterGroup of pageresult.request.filterGroups ) {
      let selected = filterGroup.values.where( combine( validValue, isSelected ) ).select( i => translateProperty( i.properties ) ).join( '; ' );
      if ( !selected && filterGroup.values.where( combine( validValue, isAssignable ) ).count() === 1 ) {
        selected = translateProperty( filterGroup.values.firstOrDefault( combine( validValue, isAssignable ) ).properties );
      }
      const translated = translateProperty( filterGroup.properties, filterGroup.name );

      if( selected && notShownValues.none( value => value === translated.toUpperCase() || value === selected.toUpperCase() ) ) {
        selectedFilters.push( <p key={ translated }>{ `${translated}: ${selected}` }</p> );
      }
    }
    
    return selectedFilters;
  }

  getCustomLayout = item => {
    const { currentNode } = this.props;

    if( !item || item.obsolete ) {
      return 'unavailable';
    }

    return currentNode.customProperties && currentNode.customProperties.productListTemplate;
  }

  allRequiredSet = () => {
    const { currentNode, filterSelectors } = this.props;

    if( currentNode.customProperties.allRequiredRequired && filterSelectors ) {
      for( let filterSelector of filterSelectors ) {
        if( filterSelector.properties.Required && filterSelector.values.none( value => value.isSelected ) ) {
          return false;
        }
      }
    }

    return true;
  }
  
  setProductsPerPage(products){
    this.setState({currentProducts:products})
  }

  prepareProducts(){
    const { pageresult } = this.props;
    let { results } = pageresult;
    results = results;
    let products = results;
    if(this.props.fromConfiguratorSelector){
      products = products.map(product=> {return {...product, ["hideConfigureButton"]:true}})
    }
    let translateddata=[];
    products.forEach(item=>{
      translateddata.push(addMetadataTranslation(item,pageresult.request.filterGroups))
    })
    return translateddata
  }

  isExpandable = item => {
    if ( item?.bomItems?.length ) {
      return true;
    } 
    return false;
  }

  setCurrentItem = (item)=>{
    this.setState({currentItem:item})
  }

  toogleItemDetails = (item)=>{
    if(!this.state.showItemDetails){
      this.setCurrentItem(item)
    }
    else{
      this.setCurrentItem({})
    }
    this.setState({showItemDetails:!this.state.showItemDetails})
  }

  totalRows = []
  renderContent( layout, item, key ) {
      return <CustomContent key={ key } layout={ layout } data={ item } view={this.props.view} accessorylength= {this.getAccessoriesLength(item)} />;
  }

  renderColumn( layout, item, key, count ) {

    let content = layout.rows
      ? layout.rows.map( ( row, key ) => this.renderRow( row, item, key, count ) )
      : this.renderContent( layout, item, key );
    
    const className = `col-${key}`;
    return <div className={className} key={key}>{ content }</div>
  }

  renderRow = (layout, item, key, count)=>{
    const content = layout.columns
      ? layout.columns.map( ( col, key) => this.renderColumn( col, item, key, count+1 ) )
      : this.renderContent( layout, item, key );
    
      const className = `count-${count}`
    return <div key={key} className={className}>{ content }</div>
  }

  toggleExpand = (key)=>{
    if(!this.state.expandedItemKeys.includes(key)){
      let arr = this.state.expandedItemKeys;
      arr.push(key);
      this.setState({expandedItemKeys:arr})
    }
    else{
      let arr = this.state.expandedItemKeys;
      let index = arr.indexOf(key);
      if (index > -1) {
        arr.splice(index, 1);
      }
      this.setState({expandedItemKeys:arr})
    }
  }

  getItems=(item)=>{
    const { bomItems, amount } = item;
    if( bomItems?.length ){
      return bomItems.map(b => ({
        name: b.value.name, 
        code: b.value.name, 
        amount: amount || 1,
        description: b.value.value
      }));
    }
    return [];
  }
  getAccessoriesLength=(item)=>{
      const accessories=getAccessories(item)
      return accessories? accessories.length:0
    }
  render() {
    const { pageresult, currentSelector, filterSelectors,fromConfiguratorSelector } = this.props;

    if ( !pageresult ) {
      return null;
    }
    let { results } = pageresult;
    results = this.allRequiredSet() ? results:[];
    let metaData = mergedMetaDataWithBomItemsTranslations( pageresult.request.metaData, pageresult.request.filterGroups );
    results = this.getCompleteProductsSet(results, metaData);

    const tooltip = this.getTooltip();
    const totalItems = pageresult.totalItems;
//add translation to these
let translateddata=[];
pageresult.results.forEach(item=>{
  translateddata.push(addMetadataTranslation(item,pageresult.request.filterGroups))
})
    let productsData = results;
    let startIndex = (this.state.page)*this.state.rowsPerPage;
    let lastIndex = startIndex+this.state.rowsPerPage;
    let productData = productsData
    lastIndex = lastIndex>productData.length?productData.length:lastIndex;

    let showAvailability = this.props.viewSettings["product"]["desktop"]["simple"]?.rows[0].columns.filter(c=>c.title==="Availability").length === 1
    let showPriceColumn = this.props.viewSettings["product"]["desktop"]["simple"]?.rows[0].columns.filter(c=>c.title==="Price" || c.title==="PURCHASEPRICE").length === 1

    const productsViewer =  <ProductsViewer
      metaData={ mergedMetaDataWithBomItemsTranslations( pageresult.request.metaData, pageresult.request.filterGroups ) } 
      onConfigureRequest={ this.handleConfigureByCode }
      products={ this.allRequiredSet() ? this.state.currentProducts : [] } 
      totalItems={ this.allRequiredSet() ? totalItems: [] } 
      onScroll={ this.onScrollHandler } 
      useCustomLayout={ this.getCustomLayout }
      onFilterChanged={ this.onFilterChanged }
      tooltip={ tooltip }
      currentSelector={ currentSelector }
      filterSelectors={ filterSelectors }
      hasStockFilter={this.props.pageresult.request.hasStockFilter || this.props.pageresult.request.override}
      view={this.props.view? this.props.view:"product"}
      currentView= { "ProductsViewer" }
      fromConfiguratorSelector={fromConfiguratorSelector}
      isProductPage={true}
      open={this.state.open}
      onOpen={this.open}
      onClose={this.close}
      isLoading={this.state.isLoading}
      resetHeader = {this.props.resetHeader}
      items={translateddata}
    />

    const mobileProductsViewer =  <ProductsViewer
    metaData={ mergedMetaDataWithBomItemsTranslations( pageresult.request.metaData, pageresult.request.filterGroups ) } 
    onConfigureRequest={ this.handleConfigureByCode }
    products={ this.allRequiredSet() ? this.prepareProducts() : [] } 
    totalItems={ this.allRequiredSet() ? pageresult.totalItems : 0 } 
    onScroll={ this.onScrollHandler } 
    useCustomLayout={ this.getCustomLayout }
    onFilterChanged={ this.onFilterChanged }
    tooltip={ tooltip }
    currentSelector={ currentSelector }
    filterSelectors={ filterSelectors }
    hasStockFilter={this.props.pageresult.request.hasStockFilter || this.props.pageresult.request.override}
    view={this.props.view? this.props.view:"product"}
    currentView= { "ProductsViewer" } //passing currentView as a prop to reduce multple api calls
    className = {"mobile-list-view"}
    template = {BomItem}
    fromModelConfiguratorSelector
     items={translateddata}
    />

    const showStockFilter = this.props.siteSettings.showStockFilter ;
    const hasStockFilter = this.props.pageresult.request.hasStockFilter || this.props.pageresult.request.override;
    return(<>
      <Box className={classNames("ProductList-Container", {"no-pagination":totalItems<=10, "single-item":totalItems===1})} sx={{height:"100%", display:{md:"flex", xs:"none"}, flexDirection:"column"}}>
      {/* <Box sx={{height:"5%", marginY:"10px"}}>
        <span className='bold-font'>{`Results (${pageresult.totalItems} items)`}</span>
      </Box> */}
      <Box className="productViewer-container" sx={{height:"83%"}}>
        {productsViewer}
      </Box>
      {
      <Pagination {...this.props} pageresult={pageresult} callNextPage={this.nextPage} setProductsPerPage={this.setProductsPerPage}></Pagination>
      }
    </Box>
      {results.length===0?<Box sx={{height:"100%", width:"100%",flexDirection:"column", display:{md:"none", xs:"flex"}}}>
      {showStockFilter&&<StockFilter hasStockFilter={hasStockFilter} currentSelector={ currentSelector } filterSelectors={ filterSelectors } active={true} />}
          <NoResultsFound show isProductPage={true} currentSelector={currentSelector}></NoResultsFound>
      </Box>:
      <Box className={classNames("product-list-container", {"single-item":totalItems===1})} height="100%" overflow="auto" sx={{display:{md:"none", xs:"flex"}, flexDirection:"column"}} onScroll={ this.onScrollHandler }>
       {showStockFilter&&<StockFilter hasStockFilter={hasStockFilter} currentSelector={ currentSelector } filterSelectors={ filterSelectors } active={false} />}
        {this.props.fromConfiguratorSelector && this.props.view==="modelconfiguratorproduct"?<>{mobileProductsViewer}</>:<div className='mobile-serch-product-container'>{results.map((item, key)=>{return(
                <div key={key} className='mobile-search-product'>
                  <div className='main-item'>
                  <div className='item-container'>
                  <div style={{height:"max-content", width:"40%", display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"center"}}>
                  {
                    this.isExpandable( item ) &&<Box sx={{display:"flex", flexDirection:"column", justifyCounter:"center", alignItems:"center"}}>
                    <div className='accessory-count-badge'>
                      <span>
                        {Object.values( this.getItems(item) )?.length}
                      </span>
                    </div>
                     <div key={ `${ key }_expander` } className={classNames("expandable-indicator icon-button",{"expanded":this.state.expandedItemKeys.includes(key)})}>
                    <SvgImage source={ arrowRightIcon } toolTip={ translate( 'Show Configuration' ) } onClick={()=>this.toggleExpand(key)} />
                    </div></Box>
                    } 
                    {
                    !this.isExpandable( item ) && <div key={ `${ key }_expander` } className="non-expandable-indicator">
                    <SvgImage source={ arrowRightIcon } toolTip={ translate( 'Show Configuration' ) } />
                    </div>
                  }
                   <ProductImage product={ item } alt={ item.productCode } onClick={this.toogleItemDetails} currentItem={item} mobileProductView={true} className="image-container" />
                </div> 

                    <div className='item-section'>
                      <div className='item-details'>
                        <ProductCode { ...item } accessorylength= {this.getAccessoriesLength(item)}  />
                        <ProductDescription product={ item } ></ProductDescription>
                        <ProductDescription product={ item } shortdescriptioncn/>
                        {showAvailability && <ProductStock product={item} currentView = { "ProductsViewer" }></ProductStock>}
                      </div>
                        {showPriceColumn&&<div className='item-price'>
                        <ProductPrice fromSelect product={item} currentView = { "ProductsViewer" }></ProductPrice>
                      </div>}
                      <div className='item-action'>
                      <ActionPanel open={this.state.open} onOpen={this.open} onClose={this.close} showQuantityView={false} mobileSearchView configure quantity add product={ item } />
                      </div>
                    </div>
                  </div>
                  </div>
                  {this.state.expandedItemKeys.includes(key)&&<ProductItemDetail showPriceColumn={showPriceColumn} showAvailability={showAvailability} key={key} {...item}></ProductItemDetail>}
                </div>
                )})}
                </div>}
                <Drawer anchor='bottom' open={this.state.showItemDetails} onClose={this.toogleItemDetails}
                PaperProps={{
                  sx: {
                    boxShadow:"none",
                    borderRadius: "12px 12px 0px 0px",
                    background: "var(--brand-primary-white, #FFF)"
                  }
                }}>
                  <div className='mobile-item-details'>
                  <div className='close-icon'>
                      <Box component="img" sx={{width:"18px", height:"18px"}} src={closePopup} onClick={this.toogleItemDetails}></Box>
                    </div>
                    <div className='header-frame'>
                      <span className='header'>{translate("Item Details")}</span>
                      <div className='product-details'>
                        <ProductCode { ...this.state.currentItem } />
                        <ProductDescription product={ this.state.currentItem } ></ProductDescription>
                      </div>
                    </div>
                    {this.props.viewSettings["product"]["desktop"]["detailed"].rows[0].columns
                      .filter(column=>column.rows)
                      .map(column=>column.rows)
                      .map((row)=>{return<>
                        <Box sx={{height:"1px", width:"100%", background: "var(--primary-color-grey-10, #EBEBEB)"}}></Box>
                        <div className='extra-details'>{row.map((row, key)=>this.renderRow(row, this.state.currentItem, key, 0))}</div>
                      </>})}
                    <div className='link-container'>
                      <a href={ getProductLink( this.state.currentItem.name ) } target="_blank">
                        <div className='link-box'>
                          <Box sx={{width:"16px", height:"16px"}} component="img" src={OpenInNewWindow}></Box>
                          <span>{translate("Go to product page")}</span>
                        </div>
                      </a>
                    </div>
                  </div>
                </Drawer>
      </Box>}</>
    )
  }
}

ProductsListComponent.propTypes = {
  currentNode: PropTypes.shape( { 
    customProperties: PropTypes.shape( {
      allRequiredRequired: PropTypes.bool,
      productListTemplate: PropTypes.string
    } )
  } ),
  currentSelector: PropTypes.shape( {
    modelToLoad: PropTypes.string,
    selector: PropTypes.object
  } ), 
  filterSelectors: PropTypes.arrayOf( PropTypes.object ),
  pageresult: PropTypes.shape( {
    page: PropTypes.number.isRequired,
    request: PropTypes.shape( {
      filterGroups: PropTypes.array.isRequired
    } ),
    results: PropTypes.array,
    totalItems: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired
  } ),
  updateSelectedValue: PropTypes.func.isRequired,
  onConfigureRequest: PropTypes.func
};

ProductsListComponent.childContextTypes = {
  modelToLoad: PropTypes.string,
  properties: PropTypes.shape( {} ),
  filterSelectors: PropTypes.array
};

export const ProductsList = name => connect( 
  combineStates( identityState, currentNodeState,productState,viewSettingsState, filterSelectorState( 'selector' )( name ), pageresultState( 'products' )( name ), repositoryState( 'selector' ), siteSettingsState ), 
  filterDispatcher
)( ProductsListComponent );
